module.exports = __webpack_public_path__ + "img/emptyBlue.1200deb4.png";